module.exports = __webpack_public_path__ + "img/dox-pair.41f09c0d.svg";